import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Inicial from './pages/Inicial'
import Chamado from './pages/Chamado'
import Login from "./pages/Login";
import CadastroUsuario from "./pages/CadastroUsuario";
import Apresentacao from "./pages/Apresentacao";
import PrivateRoute from "./components/PrivateRoute";
import SobreNos from "./pages/SobreNos";
import Ranking from "./pages/Ranking";
import RedefinicaoSenha from './pages/RedefinicaoDeSenha'

import './App.css';
import ChamadoBonus from "./pages/ChamadoBonus";
function App() {

  return (
    
      <Router>
        <AuthProvider>
        <Routes>
          {/* Rotas públicas */}
          <Route path='/cadastrar'element={<CadastroUsuario />}/>

          <Route path="/" element={<Navigate to="/login" replace />} />

          <Route path='/login'element={<Login />}/>

          <Route path='/reset-password'element={<RedefinicaoSenha />}/>


          {/* Rotas privadas */}
          <Route path='/inicial'element={
            <PrivateRoute  >
                <Inicial />
            </PrivateRoute>
          }/>
          <Route path='/chamado'element={
            <PrivateRoute >
              <Chamado />
            </PrivateRoute>}/>
          
          <Route path='/chamadoBonus'element={
            <PrivateRoute >
              <ChamadoBonus />
            </PrivateRoute>}/>

            <Route
              path="/apresentacao"
              element={
                  <PrivateRoute>
                      <Apresentacao />
                  </PrivateRoute>
              }
          />

            <Route path='/equipe-ti'element={
              <PrivateRoute >
                <SobreNos />
              </PrivateRoute>}/>  
            

            <Route path='/ranking'element={
            <PrivateRoute >
              <Ranking />
            </PrivateRoute>}/>

             <Route path='/chamado-bonus'element={
            <PrivateRoute >
              <ChamadoBonus />
            </PrivateRoute>}/>

  
          </Routes>
        
        </AuthProvider>
    </Router>
    
  );
}

export default App;
